export const modalToggle = (content) => {
   return (dispatch) => {

      dispatch({
         type: 'MODAL_MODAL_CLOSED',
         data: content
      })

   }
}


// WEBPACK FOOTER //
// ./src/actions/modalActions.js